module.exports = __webpack_public_path__ + "img/ICONO19.3ae9e61a.png";